import { CapacitorHttp } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { isPlatform } from '@ionic/vue';
import axios from 'axios';

export interface IAppRuntimeConfig {
  updatePromptEnabled: boolean;
  updatePromptVersion: number;
  updatePromptMessage: string;
}

export interface IAppRuntimeConfigUpdate extends Partial<IAppRuntimeConfig> {
  bumpPromptVersion?: boolean;
}

class AppConfigService {
  async getPublicConfig(): Promise<IAppRuntimeConfig | null> {
    try {
      if (isPlatform('ios') || isPlatform('android')) {
        const tokenQuery = await Preferences.get({ key: 'jwt' });
        const headers: Record<string, string> = {};
        if (tokenQuery.value) {
          headers.Authorization = `Bearer ${tokenQuery.value}`;
        }
        const res = await CapacitorHttp.request({
          method: 'GET',
          url: `${process.env.VUE_APP_API_URL}api/public/app-config`,
          headers,
          readTimeout: 20000,
        });
        if (res.status !== 200 || !res.data) return null;
        return normalizeConfig(res.data);
      }
      const { data } = await axios.get<IAppRuntimeConfig>('api/public/app-config');
      return normalizeConfig(data);
    } catch (e) {
      console.warn('getPublicConfig failed', e);
      return null;
    }
  }

  async getAdminConfig(): Promise<IAppRuntimeConfig | null> {
    try {
      const { data } = await axios.get<IAppRuntimeConfig>('api/admin/app-config');
      return normalizeConfig(data);
    } catch (e) {
      console.warn('getAdminConfig failed', e);
      return null;
    }
  }

  async saveAdminConfig(payload: IAppRuntimeConfigUpdate): Promise<IAppRuntimeConfig | null> {
    const { data } = await axios.put<IAppRuntimeConfig>('api/admin/app-config', payload);
    return normalizeConfig(data);
  }
}

function normalizeConfig(raw: Partial<IAppRuntimeConfig> | null | undefined): IAppRuntimeConfig {
  return {
    updatePromptEnabled: !!raw?.updatePromptEnabled,
    updatePromptVersion: Number(raw?.updatePromptVersion) || 0,
    updatePromptMessage:
      (raw?.updatePromptMessage || '').trim() ||
      'Доступна новая версия приложения. Обновите Liga.Team, чтобы пользоваться актуальными функциями и исправлениями.',
  };
}

export const appConfigService = new AppConfigService();
export default appConfigService;
